import { inject, reactive } from 'vue';

const map = {};

export default function useCustomColumn(key, customColumns, defaultColumns, apiTool = null, popupTool = null) {
  const api = inject('api') || apiTool;
  const popup = inject('popup') || popupTool;
  const curColumns = reactive([]);

  async function getColumns() {
    if (!map[key]) {
      map[key] = [];
      const res = await api.findConfigPersonaliseList({
        type: 0,
        code: key,
      });
      const obj = res.data.find((item) => item.code === key);
      if (!obj) {
        map[key] = defaultColumns;
      } else {
        map[key] = obj?.configJson?.columnList;
      }
    }
    curColumns.length = 0;
    curColumns.push(...map[key]);
    return map[key];
  }
  const pro = getColumns();
  async function selectColumn() {
    await pro;
    map[key] = await popup('column-chooser', {
      tableId: key,
      currentColumns: curColumns,
      customColumns,
    });
    curColumns.length = 0;
    curColumns.push(...map[key]);
  }

  return {
    selectColumn,
    curColumns,
  };
}
